import React, { useState, useEffect } from 'react';
import './BackgroundImageWithSkeleton.scss';
import Skeleton from '../Skeleton/Skeleton';
import { useMediaQuery } from 'react-responsive';
import { baseStrapiURL } from '../../services/config';

const BackgroundImageWithSkeleton = ({
    picture,
    width,
    height,
    children,
    className = "",
    opacityBlock = false,
    opacityBlockColor = "#361215",
    positionMobile,
    positionDesktop,
    borderRadius,
    isLoading
}) => {
    const isMobile = useMediaQuery({ maxWidth: 768 });
    const [backgroundImage, setBackgroundImage] = useState(picture ? baseStrapiURL + picture.url : null); // Définir fallbackUrl par défaut
    const [isImageLoaded, setIsImageLoaded] = useState(false);

    useEffect(() => {
        const img = new Image();
        img.src = picture ? baseStrapiURL + picture.url : null;
        img.onload = () => {
            setBackgroundImage(picture ? baseStrapiURL + picture.url : null);
            setIsImageLoaded(true);
        };
    }, [picture]);

    return (
        <>
            {!isImageLoaded && isLoading ? (
                <Skeleton
                    width={width}
                    height={height}
                    bkgColor="#EEE6DB"
                    animColor="#F5F0ED"
                    margin="0"
                    borderRadius={borderRadius}
                />
            ) : (
                <div
                    className={`background-image-skeleton ${className}`}
                    aria-label={picture ? picture.alternativeText : null}
                    style={{
                        backgroundImage: `url(${backgroundImage})`,
                        width,
                        height,
                        position: isMobile ? positionMobile : positionDesktop,
                        borderRadius,
                    }}
                >
                    {opacityBlock && (
                        <div
                            className="background-image-skeleton__opacity-block"
                            style={{
                                backgroundColor: opacityBlockColor,
                            }}
                        />
                    )}
                    {children}
                </div>
            )}
        </>
    );
};

export default BackgroundImageWithSkeleton;